import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: false
})
export class SearchPipe implements PipeTransform {
  transform(items: any, term: any, includes: any): Array<any> {
    if (items?.length == 0 || !term) {
      return items;
    }
    let retval = items.map((obj: any) => {
      obj['include'] = false;
      for (let key of includes) {
        let searchText: string = '';
        searchText = obj[key].toString().toLowerCase();
        if (searchText.includes(term.toLowerCase())) {
          obj['include'] = true;
        }
      }
      return obj;
    });
    return retval.filter((e: any) => {
      return e['include'] == true;
    });
  }
}
